import { css } from "@emotion/css"

import OneClickErrorText from "../../components/1Click/OneClickErrorText"
import COLOR_CODE from "../../constant/color"

type Props = { errors: [string, ...string[]] }

const ErrorMessages = ({ errors }: Props) => {
  return (
    <div className={style}>
      {errors.map((error, i) => (
        <OneClickErrorText key={i}>{error}</OneClickErrorText>
      ))}
    </div>
  )
}

export default ErrorMessages

const style = css`
  padding: 10px;
  background-color: ${COLOR_CODE.WHITE};
  border: 1px solid ${COLOR_CODE.GREEN};
  margin-bottom: 16px;
`
